export enum CalculatedState {
  CALCULATED = "CALCULATED",
  OVERRIDDEN = "OVERRIDDEN",
}
